import styled from 'styled-components'
import themeAssetloadingSquareLoadingSvg from '@theme/loading/square-loading.svg'

export const Image = styled.img`
  width: 100%;
  height: 4.282rem;
  border-radius: 0.2564rem;
  background: url(${themeAssetloadingSquareLoadingSvg}) no-repeat center;
  background-size: cover;
  transition: background 0.2s ease-in;
`
